export default __webpack_public_path__ + "static/media/Avatar.ddd911d2.png";